import { Component, OnInit } from '@angular/core';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { BillingService } from 'src/home/billing/services/billing.service';
import { HomeService } from 'src/home/home.service';
import { PaginatorService } from 'src/home/paginator.service';
import { Client } from 'src/models/client-code.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-client-codes-list',
  templateUrl: './client-codes-list.component.html',
  styleUrls: ['./client-codes-list.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }],

})
export class ClientCodesListComponent {
  clientCodes: Client[] = [];
  displayedClients: Client[] = [];
  isLoading: boolean = false;
  organizationCif: string = '';
  searchInitiated: boolean = false;

  pageSizeOptions: number[] = [10, 20, 50];
  totalClients: number = 0;
  pageSize = 10;
  pageIndex = 0;

  constructor(private homeService: HomeService, private billingService: BillingService) { }




  handleGetClientCodes(): void {
    if (!this.organizationCif) {
      return;
    }
    this.searchInitiated = true;
    this.isLoading = true;
    this.billingService.getClientCodes(this.organizationCif)
      .subscribe(
        (response: any) => {
          this.isLoading = false;
          if (response && response.length > 0) {
            this.clientCodes = response
          } else {
            Swal.fire({
              icon: 'info',
              title: 'No se encontraron códigos de cliente',
              text: 'Por favor, intente con otro código CIF',
            });
          }
          this.updateDisplayedClients();

        },
        (error) => {
          this.isLoading = false;
          console.error('Error al obtener códigos de cliente:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener códigos de cliente',
            text: 'Por favor, inténtelo de nuevo más tarde',
          });
          this.clientCodes = [];
          this.isLoading = false;
        }
      );
  }


  handlePageEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updateDisplayedClients();
  }

  updateDisplayedClients(): void {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayedClients = this.clientCodes.slice(startIndex, endIndex);
  }


}
